import React from "react";
import { Outlet } from "react-router-dom";
import NavBar from "./NavBar";
import Footer from "./Footer";
import ScrollToTop from "./ScrollToTop";
import ScrollToHash from "./ScrollToHash";

export default function AppLayout() {
  return (
    <>
      <NavBar />
      <ScrollToTop />
      <ScrollToHash />
      <Outlet />
      <Footer />
    </>
  );
}
